angular.module('rjmNg.directives').directive "sqlChartOption", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlChartOption.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      columns: "="
      selectedSeries: "="
      selectedCategories: "="
      selectedLabels: "="
    controller: [
      "$rootScope"
      (
        $rootScope
      ) ->

        view = @

        view.setCategory = (name) ->
          $rootScope.$broadcast "setCategory", name

        addCategory = (name) ->
          $rootScope.$broadcast "addCategory", name

        addSeries = (name) ->
          $rootScope.$broadcast "addSeries", name

        addLabel = (name) ->
          $rootScope.$broadcast "addLabel", name

        view.removeCategory = (name) ->
          $rootScope.$broadcast "removeCategory", name

        view.removeSeries = (name) ->
          $rootScope.$broadcast "removeSeries", name

        view.removeLabel = (name) ->
          $rootScope.$broadcast "removeLabel", name

        view.toggleCategory = (name) ->
          if name in view.selectedCategories
            removeCategory(name)
          else
            addCategory(name)

        view.toggleSeries = (name) ->
          if name in view.selectedSeries
            removeSeries(name)
          else
            addSeries(name)

        view.toggleLabel = (name) ->
          if name in view.selectedLabels
            removeLabel(name)
          else
            addLabel(name)

        return view
    ]
]
